<template>
  <v-layout column class="cluster-wrapper" :class="layout">
    <v-layout v-if="tabs" class="tabs">
      <v-flex
        fill-height
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab align-items-center"
        :class="{ active: tab.isShown }"
        @click="tab.action">
        {{ index }}
      </v-flex>
    </v-layout>
    <v-flex v-if="title" class="align-items-center">
      <span>{{ title }}</span>
    </v-flex>
    <v-flex v-if="component">
      <component :is="component.name" :bind="component.params"></component>
    </v-flex>
    <v-flex class="align-items-center">
      <span v-if="icon && !route" @click="$emit('clickHandler')">
        <v-icon v-if="icon.FAclass">{{ icon.FAclass }}</v-icon>
        <img
          v-else
          :src="imgPath"
          @error="defaultImageProfile($event)"
          style="height: 40px" />
      </span>
      <template v-else>
        <template v-if="route">
          <div
            :class="{
              'mr-3': route.marginRight,
              'success--text': route.success,
            }">
            <router-link custom v-slot="{ navigate }" :to="route.link">
              <button @click="navigate" role="link">
                <template v-if="icon">
                  <v-icon v-if="icon.FAclass">{{ icon.FAclass }}</v-icon>
                  <v-img
                    v-else
                    :src="imgPath"
                    lazy-src="imgPath"
                    @error="defaultImageProfile($event)"
                    class="profile-img"></v-img>
                </template>
                <template v-if="route && route.title">
                  <span>{{ route.title }}</span>
                </template>
              </button>
            </router-link>
          </div>
        </template>
      </template>
    </v-flex>
    <v-flex v-if="text" class="align-items-center">{{ text }}</v-flex>
  </v-layout>
</template>

<script>
import MultiTeamSelect from "@/components/shared/common/MultiTeamSelect.vue"

export default {
  name: "HeaderValues",
  components: { MultiTeamSelect },
  props: ["component", "tabs", "title", "icon", "route", "layout", "text"],
  computed: {
    imgPath() {
      if (this.icon.path === "n/a" && this.icon.path) {
        return require("@/assets/icons/defaultProfileImg.png").default
      } else {
        return this.icon.path
      }
    },
  },
  methods: {
    siblings(node) {
      return [...node.parentElement.children].filter((el) => el !== node)
    },

    defaultImageProfile(event) {
      event.target.src = require("@/assets/icons/defaultProfileImg.png").default
    },
  },
}
</script>

<style scoped lang="sass">
@import '@/assets/sass/globals.sass'
*
  max-height: 40px

img
  display: flex
  align-self: center

.profile-img
  height: 40px
  width: 40px
  border-radius: 50%

.cluster-wrapper
  color: $white
  font:
    weight: 600
    size: 1.4em
  text-align: center
  flex: 0 1 auto

.left-side, .right-side
  display: flex
  flex: 0 1 auto
  justify-content: center
  align-items: center
  cursor: pointer

  & > *
    display: flex !important

.middle
  display: flex
  flex: 2 1 auto
  justify-content: center

  & > div
    display: flex
    align-self: center
    align-items: center

  .tabs
    height: 100%
    cursor: pointer
    border-radius: 8px
    border: 1px solid $white
    font:
      size: 0.7em
      weight: 500
    overflow: hidden

    .tab
      display: flex
      align-items: center
      padding: 0 1em
      transition: all 250ms ease-in-out

      &:hover
        background:
          color: $white
        color: $light-gray

    .active
      background:
        color: $white
      color: $light-gray

.img-circle > div
  display: flex

  img
    border-radius: 50%
    width: 40px
</style>
